<template>
  <div class="EnterpriseCulture">
    <div class="banner"></div>
    <div class="center">
      <div class="content">
        <!-- 分蛋简介 -->
        <div class="intro-part">
          <p class="title">分蛋简介</p>
          <div class="intro-company">
            <div class="logo">
              <img src="../../assets/images/main-img.png" alt />
            </div>
            <div class="information">
              <p class="title">上海分蛋信息科技有限公司</p>
              <p class="text">
                上海分蛋信息科技有限公司是一家专注于服务新生家庭在消费及零售领域的科技型企业。
                致力于为新生家庭提供一站式全场景服务，包括婚嫁、母婴及早教等领域，通过大数据及人工智能等技术的运用，满足新生家庭的在消费版块的全方位需求。
              </p>
              <div class="cooperation">
                <span v-for="item in 6" :key="item">
                  <i class="iconfont icon-shapecopy4"></i>
                  广东省摄影行业协会理事单位
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- 分界线 -->
        <div></div>

        <!-- 分蛋科技价值观 -->
        <div class="intro-part">
          <p class="title">分蛋科技价值观</p>
          <div class="intro-values">
            <div class="values-item" v-for="item in 4" :key="item">
              <p class="values-title"><i class="iconfont icon-icon04"></i>客户为先</p>
              <p class="values-cont">
                尊重（内外部）客户，及时响应客户需求，快速解决客户问题，站在客户立场思考和推进工作，深入了解客户需求的变化，提供超出客户预期的产品和服务。
              </p>
            </div>
          </div>
        </div>

        <div class="carousel-view">
          <div v-for="i in 3" :key="i" class="carousel-item">
            <span class="carousel-title">分蛋有优雅的环境</span>
            <el-carousel indicator-position="outside" :autoplay="false" arrow="never">
              <el-carousel-item v-for="item in 3" :key="item">
                <img src="../../assets/images/watch.png" alt />
                <p>在分蛋，你可以享受到温馨优越的办公环境、贴心周到的专属照顾以及人性化的便利设施。</p>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EnterpriseCulture',
  data() {
    return {}
  },

  methods: {}
}
</script>

<style lang="scss">
$themeColor: #4f8dfe;
.EnterpriseCulture {
  font-size: 14px;
  .banner {
    background: #2b6fec;
    height: 200px;
    background-image: url('../../assets/images/企业文化_02.png');
    background-size: cover;
    background-position: center;
    @media screen and (max-width: 414px) {
      display: none;
    }
  }
  .center {
    width: 62.5%;
    margin: 0 auto;
    @media screen and (max-width: 414px) {
      width: 100%;
    }
    .content {
      width: 100%;
      margin: 45px 0 68px;
      background: #fff;
      padding: 20px 0;
      @media screen and (max-width: 414px) {
        margin: 0;
      }
      .intro-part {
        padding: 0 40px;
        @media screen and (max-width: 414px) {
          padding: 0 10px;
        }
        & > .title {
          font-size: 20px;
          font-weight: bold;
          padding: 10px 0;
          &::before {
            content: '';
            display: inline-block;
            width: 11px;
            height: 11px;
            background: rgba(79, 141, 254, 1);
            border-radius: 50%;
            margin-right: 5px;
          }
        }
        .intro-company {
          display: flex;
          @media screen and (max-width: 414px) {
            display: block;
          }
          .logo {
            width: 483px;
            height: 343px;
            background: rgba(244, 244, 244, 1);
            position: relative;
            margin: 0 0 0 25px;
            @media screen and (max-width: 414px) {
              width: 300px;
              height: 214px;
              margin: 0 auto;
              transform: translateX(20px);
            }
            img {
              position: absolute;
              top: 22px;
              right: 48px;
              width: 460px;
              height: 369px;
              @media screen and (max-width: 414px) {
                top: 15px;
                right: 20px;
                width: 300px;
                height: 214px;
              }
            }
          }
          .information {
            text-align: center;
            color: #333;
            padding: 0 56px 0 46px;
            flex: 1;
            @media screen and (max-width: 414px) {
              padding: 0;
            }
            .title {
              font-size: 19px;
              padding: 40px 0;
              @media screen and (max-width: 414px) {
                padding: 20px 0;
              }
            }
            .text {
              line-height: 25px;
            }
            .cooperation {
              display: flex;
              flex-wrap: wrap;
              margin-top: 90px;
              text-align: left;
              @media screen and (max-width: 414px) {
                margin-top: 30px;
              }
              span {
                box-sizing: border-box;
                width: 50%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                display: flex;
                // float: left;
                padding: 8px 0;
                .iconfont {
                  color: #f68606;
                  font-size: 18px;
                }
              }
            }
          }
        }
        .intro-values {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          .values-item {
            width: 42%;
            padding: 20px 0;
            @media screen and (max-width: 414px) {
              box-sizing: border-box;
              width: 100%;
              padding-bottom: 0;
            }
            .values-title {
              font-size: 18px;
              color: #333;
              display: flex;
              align-items: center;
              .iconfont {
                color: $themeColor;
                font-size: 44px;
                margin-right: 10px;
              }
            }
            .values-cont {
              color: #666;
              text-indent: 28px;
              line-height: 28px;
            }
          }
        }
      }
      .carousel-view {
        display: flex;
        justify-content: space-around;
        padding: 80px 0;
        .carousel-item {
          width: 28.75%;
          position: relative;
        }
        @media screen and (max-width: 414px) {
          display: block;
          .carousel-item {
            box-sizing: border-box;
            width: 100%;
          }
        }
        .carousel-title {
          position: absolute;
          top: -12px;
          left: 25px;
          font-size: 18px;
          color: #666;
          z-index: 2;
          padding: 0 24px 0 7px;
          background: #fff;
        }
        .el-carousel {
          border: 1px solid #e4e4e4;
          padding-bottom: 30px;
          .el-carousel__item {
            display: flex;
            flex-direction: column;
            align-items: center;
            // padding: 0 26px;
            & > img {
              height: 182px;
              margin: 30px 0 24px;
            }
            & > p {
              color: #666;
              line-height: 26px;
            }
            & > img,
            & > p {
              width: 85%;
            }
          }
        }
      }
    }
  }
}
</style>
